
export const siteGuardUserPermissions: UserPermission[] = [
    {
        name: "Monitoring",
        route: "monitoring",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Transactions",
        route: "transactions",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Dashboard",
        route: "dashboard",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Alarm Viewer",
        route: "alarms",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    // {
    //     name: "Modules",
    //     route: "modules",
    //     showListItem: true,
    //     addElements: true,
    //     deleteElements: true,
    //     updateElements: true
    // },
    // {
    //     name: "Scheduled Tours",
    //     route: "scheduled-tours",
    //     showListItem: true,
    //     addElements: true,
    //     deleteElements: true,
    //     updateElements: true
    // }
    {
        name: "Reports",
        route: "reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Transaction",
        route: "transaction-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "transaction-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "time-attendance-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Time & Attendance",
        route: "time-attendance-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "my-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "My Reports",
        route: "my-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "access-control-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Access Control",
        route: "access-control-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "system-setup-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "System Setup",
        route: "system-setup-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "emergency-safety-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Emergency & Safety",
        route: "emergency-safety-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "compliance-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Compliance",
        route: "compliance-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
]
